import { combineReducers } from "@reduxjs/toolkit";
import { reducer as adminReducer } from "src/slices/admin";
import { reducer as regionReducer } from "src/slices/region";
import { reducer as conditionReducer } from "src/slices/condition";
import { reducer as configReducer } from "src/slices/config";
import { reducer as gunguScrollReducer } from "src/slices/gungu-scroll";
import { reducer as analyzeReducer } from "src/slices/analyze";
import { reducer as rankReducer } from "src/slices/rank";
import { reducer as datalakeReducer } from "src/slices/datalake";
import { reducer as datatypeReducer } from "src/slices/datatype";
import { reducer as orderReducer } from "src/slices/order";
import { reducer as groupReducer } from "src/slices/group";
import { reducer as dashboardHomeReducer } from "src/slices/dashboard-home";

export const rootReducer = combineReducers({
  admin: adminReducer,
  region: regionReducer,
  condition: conditionReducer,
  config: configReducer,
  gunguScroll: gunguScrollReducer,
  analyze: analyzeReducer,
  rank: rankReducer,
  datalake: datalakeReducer,
  datatype: datatypeReducer,
  order: orderReducer,
  group: groupReducer,
  dashboardHome: dashboardHomeReducer,
});
